import { markRaw } from 'vue'

const OG_DATA_KEY = '$originalData'
const LODASH_DATA_KEY = '_'

const getPureDataKeys = (data) => _.without(_.keys(data), OG_DATA_KEY, LODASH_DATA_KEY)

export default {
  /** @param {import('vue').App} app */
  install (app) {
    app.mixin({
      data: () => ({
        [OG_DATA_KEY]: markRaw({}),
      }),
      created () {
        const { name = '' } = this.$options
        if (name.startsWith('Cy')) this.$setOriginalData()
      },
      methods: {
        $hasDataChanged (path) {
          const { [OG_DATA_KEY]: $originalData, [LODASH_DATA_KEY]: _, ...data } = this.$data
          return path
            ? !_.isEqual(_.$get(data, path), _.$get($originalData, path))
            : !_.isEqual(data, $originalData)
        },
        $setOriginalData (path) {
          const data = _.omit(this.$data, [OG_DATA_KEY, LODASH_DATA_KEY])
          if (path) _.set(this.$data[OG_DATA_KEY], path, _.cloneDeep(_.$get(data, path)))
          else {
            const keys = getPureDataKeys(data)
            for (const key of keys) {
              this.$data[OG_DATA_KEY][key] = _.cloneDeep(data[key])
            }
          }
        },
        $resetData (path) {
          const originalData = _.$get(this.$data, OG_DATA_KEY, this.$options.data.apply(this))
          if (path) _.set(this.$data, path, _.cloneDeep(_.$get(originalData, path)))
          else {
            const keys = getPureDataKeys(originalData)
            for (const key of keys) {
              this.$data[key] = _.cloneDeep(originalData[key])
            }
          }
        },
      },
    })
  },
}
